/// <reference path="../../node_modules/@ms/office-online-strings/en-US/transcription-strings.d.ts" />

export function FormatTime(time: number, showHours:boolean = false): string {
    let hoursString = '';
    if (showHours) {
      const hours = ("0" + Math.floor(time / 3600)).slice(-2);
      hoursString = `${hours}:`;
    }

    const minutes = ("0" + (Math.floor(time / 60) % 60)).slice(-2);
    const seconds = ("0" + (Math.floor(time) % 60)).slice(-2);
    return `${hoursString}${minutes}:${seconds}`;
}

/**
 * Formats time eg: 1 hour and 20 minutes and 40 seconds
 * @param time time in seconds
 * @param showHours true to show hours and false to hide hours
 * @param showSeconds true to show seconds and false to hide seconds
 */
export function FormatTimeDescription(time: number, showHours:boolean, showSeconds:boolean): string {
    let hours = 0;
    let hoursString = '';
    if (showHours) {
      hours = Math.floor(time / 3600);
      const hoursWord = hours == 1 ? TranscriptionStrings.TimeDescriptionHour : TranscriptionStrings.TimeDescriptionHours;
      hoursString = hours > 0 ?  `${hours} ${hoursWord}` : '';
    }

    const minutes = Math.floor(time / 60) % 60;
    const minutesWord = minutes == 1 ? TranscriptionStrings.TimeDescriptionMinute : TranscriptionStrings.TimeDescriptionMinutes;
    const minutesString = minutes > 0 ?  `${minutes} ${minutesWord}` : '';

    let seconds = 0;
    let secondsString = '';
    if(showSeconds){
      seconds = Math.floor(time) % 60;
      const secondsWord = seconds == 1 ? TranscriptionStrings.TimeDescriptionSecond : TranscriptionStrings.TimeDescriptionSeconds;
      secondsString = (seconds > 0 || minutes <= 0) ? `${seconds} ${secondsWord}` : '';
    }

    const firstAndString = hours > 0 && (minutes > 0 || seconds > 0) ? ` ${TranscriptionStrings.TimeDescriptionAnd} ` : '';
    const secondAndString = minutes > 0 && seconds > 0 ? ` ${TranscriptionStrings.TimeDescriptionAnd} ` : '';
    return  `${hoursString}${firstAndString}${minutesString}${secondAndString}${secondsString}`;
}